<template>
  <vs-row vs-type="block" vs-w="12" id="targetsPage">
    <vs-popup
      class="holamundo"
      title="Hedef Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Hedefi Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteTarget(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <target-reviewer
      ref="targetReviewer"
      :target="selectedTarget"
      @close="selectedTarget = {}"
    />
    <vs-col id="targetSide" vs-type="flex" vs-sm="12" vs-lg="6">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row
          id="targetOptions"
          vs-type="flex"
          vs-w="12"
          vs-align="center"
          class="px-4"
        >
          <vs-col
            v-if="$isCenterBranch() || $isRegionalCenterBranch()"
            vs-type="flex"
            vs-w="6.5"
            class="px-1"
          >
            <v-select
              class="w-full targetBranchSelect weight-500"
              :clearable="false"
              placeholder="Şube Seçimi"
              itemid="id"
              label="name"
              v-model="tableOptions.branch"
              :options="branches"
            />
          </vs-col>
          <vs-col v-else vs-type="flex" class="px-1 w-auto" vs-align="center">
            <span class="text-dark weight-500 text-small">
              {{ tableOptions.branch.name }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" class="px-1">
            <v-select
              class="w-full targetMonthSelect weight-500"
              :clearable="false"
              itemid="id"
              label="name"
              v-model="tableOptions.month"
              :options="$months()"
            />
          </vs-col>
          <vs-col vs-type="flex" vs-w="2.5" class="px-1">
            <v-select
              class="w-full targetYearSelect weight-500"
              :clearable="false"
              itemid="id"
              label="name"
              v-model="tableOptions.year"
              :options="$years()"
            />
          </vs-col>
        </vs-row>
        <vs-row
          id="targetDetails"
          vs-type="flex"
          vs-w="12"
          class="mt-1"
          v-if="tableOptions.branch"
        >
          <vs-collapse class="w-full">
            <vs-collapse-item
              id="branchTargets"
              class="bg-white sale-box-shadow mb-2 low-border-radius"
              :class="{ newTargetLine: newBranchTarget != null }"
            >
              <div slot="header">
                <span class="block w-full text-secondary text-small bold">
                  Şube Hedefleri
                </span>
                <div class="w-full d-flex text-xsmall weight-500 text-dark">
                  <span class="d-flex text-secondary text-xsmall bold mr-1">
                    {{ tableOptions.month.name }}
                  </span>
                  Ayı,
                  <span
                    class="d-flex text-secondary text-xsmall bold ml-1 mr-1"
                  >
                    {{ tableOptions.branch.name }}
                  </span>
                  Şubesi için
                  <span
                    class="d-flex text-secondary text-xsmall bold ml-1 mr-1"
                  >
                    {{ branchTargets.length }}
                  </span>
                  hedef belirlendi.
                </div>
                <span
                  v-if="daysToExpire != 0 && daysToExpire != null"
                  class="block w-full text-danger text-xsmaller weight-600"
                >
                  {{ daysToExpire + " Gün Kaldı" }}
                </span>
                <span
                  v-if="daysToExpire == 0 && daysToExpire != null"
                  class="block w-full text-danger text-xsmaller weight-600"
                >
                  Gün Sonunda Bitiyor
                </span>
              </div>
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" id="branchTargetList">
                  <vs-row
                    v-if="
                      ($isCenterBranch || $isRegionalCenterBranch()) &&
                      daysToExpire != null
                    "
                    vs-type="flex"
                    vs-w="12"
                    class="mb-2"
                  >
                    <transition name="slide-fade">
                      <vs-col
                        v-if="newBranchTarget == null && newTargetPermission"
                        vs-type="flex"
                        vs-w="1"
                        class="pr-1"
                        vs-align="center"
                      >
                        <vs-button
                          size="large"
                          :disabled="daysToExpire == null"
                          @click="newBranchTarget = {}"
                          class="w-full"
                          icon-pack="feather"
                          icon="icon-plus"
                          color="success"
                        />
                      </vs-col>
                      <div v-else class="d-flex w-full">
                        <vs-col vs-type="flex" vs-w="2.5" class="pr-1">
                          <v-select
                            class="w-full weight-500"
                            :clearable="false"
                            placeholder="Tür Seçiniz"
                            itemid="id"
                            label="name"
                            v-model="newBranchTarget.kind"
                            :options="targetKinds"
                          />
                        </vs-col>
                        <vs-col
                          v-if="
                            newBranchTarget.kind && newBranchTarget.kind.id == 1
                          "
                          vs-type="flex"
                          vs-w="4.5"
                          class="px-1"
                        >
                          <v-select
                            name="Ürün Seçimi"
                            class="w-full weight-500"
                            :clearable="false"
                            v-validate="'required'"
                            placeholder="Ürün Seçimi"
                            itemid="id"
                            label="name"
                            v-model="newBranchTarget.product"
                            :options="products"
                          />
                        </vs-col>
                        <vs-col
                          v-if="
                            newBranchTarget.kind && newBranchTarget.kind.id == 3
                          "
                          vs-type="flex"
                          vs-w="4.5"
                          class="px-1"
                        >
                          <v-select
                            name="Kategori Seçimi"
                            class="w-full weight-500"
                            :clearable="false"
                            v-validate="'required'"
                            placeholder="Kategori Seçimi"
                            itemid="id"
                            label="name"
                            v-model="newBranchTarget.category"
                            :options="categories"
                          />
                        </vs-col>
                        <vs-col
                          v-if="newBranchTarget.kind != null"
                          vs-type="flex"
                          vs-w="3"
                          class="px-1"
                        >
                          <vs-input
                            name="Miktar"
                            v-validate="{
                              regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,
                            }"
                            v-model="newBranchTarget.targetQuantity"
                            class="w-full"
                            :placeholder="
                              newBranchTarget.kind.id == 1 ||
                              newBranchTarget.kind.id == 3
                                ? 'Miktar Giriniz'
                                : 'Tutar Giriniz'
                            "
                          />
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-w="1"
                          class="px-1"
                          vs-align="center"
                          vs-justify="center"
                        >
                          <vs-button
                            @click="newBranchTarget = null"
                            icon-pack="feather"
                            icon="icon-x"
                            radius
                            color="danger"
                            size="small"
                          />
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-w="1"
                          class="px-1"
                          vs-align="center"
                          vs-justify="center"
                        >
                          <vs-button
                            @click="submitNewTarget"
                            :disabled="
                              newBranchTarget.targetQuantity == null ||
                              errors.has('Miktar') ||
                              (newBranchTarget.kind &&
                                newBranchTarget.kind.id == 1 &&
                                newBranchTarget.product == null)
                            "
                            icon-pack="feather"
                            icon="icon-check"
                            radius
                            color="success"
                            size="small"
                          />
                        </vs-col>
                      </div>
                    </transition>
                  </vs-row>
                  <vs-row
                    vs-type="flex"
                    vs-w="12"
                    class="branchTargetRow mb-2"
                    vs-justify="center"
                    vs-align="center"
                    v-for="(target, index) in branchTargets"
                    :key="index"
                  >
                    <vs-col
                      vs-type="flex"
                      vs-w="1"
                      vs-align="center"
                      class="pr-1"
                    >
                      <vs-button
                        v-if="target.kind == 1"
                        size="large"
                        class="w-full targetTypeAvatar"
                        type="filled"
                        color="rgb(60, 232, 196)"
                        icon-pack="pickicon"
                        icon="icon-products"
                      />
                      <vs-button
                        v-if="target.kind == 2"
                        size="large"
                        class="w-full targetTypeAvatar"
                        type="filled"
                        color="rgb(142, 224, 232)"
                        icon-pack="pickicon"
                        icon="icon-rich"
                      />
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="3"
                      vs-align="center"
                      class="px-1"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            v-if="target.kind == 1"
                            class="text-dark text-xsmall bold"
                          >
                            Ürün Hedefi
                          </span>
                          <span
                            v-if="target.kind == 2"
                            class="text-dark text-xsmall bold"
                          >
                            Ciro Hedefi
                          </span>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            v-if="target.kind == 1"
                            class="text-secondary text-xsmaller weight-600"
                          >
                            {{
                              target.targetQuantity +
                              " Adet " +
                              target.product.name
                            }}
                          </span>
                          <span
                            v-if="target.kind == 2"
                            class="text-secondary text-xsmaller weight-600"
                          >
                            {{ $toCurrency(target.targetQuantity) }}
                          </span>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="7"
                      vs-align="center"
                      class="px-1"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-progress
                            :percent="
                              (target.targetProcess * 100) /
                              target.targetQuantity
                            "
                            :color="
                              target.kind == 2
                                ? 'rgb(142, 224, 232)'
                                : 'rgb(60, 232, 196)'
                            "
                          >
                          </vs-progress>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-col
                            vs-type="flex"
                            vs-w="6"
                            vs-justify="flex-start"
                          >
                            <span
                              v-if="target.kind == 1"
                              class="text-secondary bold text-xsmall"
                            >
                              {{ target.targetProcess + " Adet" }}
                            </span>
                            <span
                              v-if="target.kind == 2"
                              class="text-secondary bold text-xsmall"
                            >
                              {{ $toCurrency(target.targetProcess) }}
                            </span>
                          </vs-col>
                          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
                            <span
                              v-if="target.kind == 1"
                              class="text-secondary bold text-xsmall"
                            >
                              {{ target.targetQuantity + " Adet" }}
                            </span>
                            <span
                              v-if="target.kind == 2"
                              class="text-secondary bold text-xsmall"
                            >
                              {{ $toCurrency(target.targetQuantity) }}
                            </span>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="1"
                      vs-align="center"
                      vs-justify="center"
                      class="pl-1 mb-3"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-4 h-4 hover:text-danger stroke-current"
                        @click.stop="
                          deletedId = target.id;
                          deletePopupActive = true;
                        "
                      />
                    </vs-col>
                  </vs-row>
                </vs-row>
              </vs-row>
            </vs-collapse-item>
            <vs-collapse-item
              id="personalTargets"
              class="bg-white sale-box-shadow mb-2 low-border-radius"
              :class="{ newTargetLine: newPersonalTarget != null }"
            >
              <div slot="header">
                <span class="block w-full text-secondary text-small bold">
                  Personel Hedefleri
                </span>
                <div class="w-full d-flex text-xsmall weight-500 text-dark">
                  <span class="d-flex text-secondary text-xsmall bold mr-1">
                    {{ tableOptions.month.name }}
                  </span>
                  Ayı,
                  <span
                    class="d-flex text-secondary text-xsmall bold ml-1 mr-1"
                  >
                    {{ tableOptions.branch.name }}
                  </span>
                  Personelleri için
                  <span
                    class="d-flex text-secondary text-xsmall bold ml-1 mr-1"
                  >
                    {{ personalTargets.length }}
                  </span>
                  hedef belirlendi.
                </div>
                <span
                  v-if="daysToExpire != 0 && daysToExpire != null"
                  class="block w-full text-danger text-xsmaller weight-600"
                >
                  {{ daysToExpire + " Gün Kaldı" }}
                </span>
                <span
                  v-if="daysToExpire == 0 && daysToExpire != null"
                  class="block w-full text-danger text-xsmaller weight-600"
                >
                  Gün Sonunda Bitiyor
                </span>
              </div>
              <vs-row vs-type="flex" vs-w="12">
                <vs-row
                  v-if="
                    ($isCenterBranch || $isRegionalCenterBranch()) &&
                    daysToExpire != null
                  "
                  vs-type="flex"
                  vs-w="12"
                  class="mb-2"
                >
                  <transition name="slide-fade">
                    <vs-col
                      v-if="newPersonalTarget == null && newTargetPermission"
                      vs-type="flex"
                      vs-w="1"
                      class="pr-1"
                      vs-align="center"
                    >
                      <vs-button
                        :disabled="daysToExpire == null"
                        @click="newPersonalTarget = {}"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="w-full"
                        size="large"
                        color="success"
                      />
                    </vs-col>
                    <div v-else class="d-flex w-full">
                      <vs-col vs-type="flex" vs-w="2.5" class="pr-1">
                        <v-select
                          class="w-full weight-500"
                          :clearable="false"
                          placeholder="Tür Seçiniz"
                          itemid="id"
                          label="name"
                          v-model="newPersonalTarget.kind"
                          :options="targetKinds"
                        />
                      </vs-col>
                      <vs-col
                        v-if="
                          newPersonalTarget.kind &&
                          newPersonalTarget.kind.id == 1
                        "
                        vs-type="flex"
                        vs-w="4.5"
                        class="px-1"
                      >
                        <v-select
                          name="Ürün Seçimi"
                          class="w-full targetBranchSelect weight-500"
                          :clearable="false"
                          v-validate="'required'"
                          placeholder="Ürün Seçimi"
                          itemid="id"
                          label="name"
                          v-model="newPersonalTarget.product"
                          :options="products"
                        />
                      </vs-col>
                      <vs-col
                        v-if="
                          newPersonalTarget.kind &&
                          newPersonalTarget.kind.id == 3
                        "
                        vs-type="flex"
                        vs-w="4.5"
                        class="px-1"
                      >
                        <v-select
                          name="Kategori Seçimi"
                          class="w-full targetBranchSelect weight-500"
                          :clearable="false"
                          v-validate="'required'"
                          placeholder="Kategori Seçimi"
                          itemid="id"
                          label="name"
                          v-model="newPersonalTarget.category"
                          :options="categories"
                        />
                      </vs-col>
                      <vs-col
                        v-if="newPersonalTarget.kind != null"
                        vs-type="flex"
                        vs-w="3"
                        class="px-1"
                      >
                        <vs-input
                          name="Miktar"
                          v-validate="{ regex: /^\d{0,10}(\.\d{0,10}){0,1}$/ }"
                          v-model="newPersonalTarget.targetQuantity"
                          class="w-full"
                          :placeholder="
                            newPersonalTarget.kind.id == 1 ||
                            newPersonalTarget.kind.id == 3
                              ? 'Miktar Giriniz'
                              : 'Tutar Giriniz'
                          "
                        />
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-w="1"
                        class="px-1"
                        vs-align="center"
                        vs-justify="center"
                      >
                        <vs-button
                          @click="newPersonalTarget = null"
                          icon-pack="feather"
                          icon="icon-x"
                          color="danger"
                          size="small"
                        />
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-w="1"
                        class="px-1"
                        vs-align="center"
                        vs-justify="center"
                      >
                        <vs-button
                          @click="submitNewTarget"
                          :disabled="
                            newPersonalTarget.targetQuantity == null ||
                            errors.has('Miktar') ||
                            (newPersonalTarget.kind &&
                              newPersonalTarget.kind.id == 1 &&
                              newPersonalTarget.product == null)
                          "
                          icon-pack="feather"
                          icon="icon-check"
                          radius
                          color="success"
                          size="small"
                        />
                      </vs-col>
                    </div>
                  </transition>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" id="personalTargetList">
                  <div
                    @click="openTargetReviewer(target)"
                    class="d-flex vs-row w-full personalTargetRow mb-2"
                    vs-justify="center"
                    vs-align="center"
                    v-for="(target, index) in personalTargets"
                    :key="index"
                  >
                    <vs-col
                      vs-type="flex"
                      vs-w="1"
                      vs-align="center"
                      class="pr-1"
                    >
                      <vs-button
                        v-if="target.kind == 1"
                        size="large"
                        class="w-full targetTypeAvatar"
                        type="filled"
                        color="rgb(60, 232, 196)"
                        icon-pack="pickicon"
                        icon="icon-products"
                      />
                      <vs-button
                        v-if="target.kind == 2"
                        size="large"
                        class="w-full targetTypeAvatar"
                        type="filled"
                        color="rgb(142, 224, 232)"
                        icon-pack="pickicon"
                        icon="icon-rich"
                      />
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="3"
                      vs-align="center"
                      class="px-1"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            v-if="target.kind == 1"
                            class="text-dark text-xsmall bold"
                          >
                            Ürün Hedefi
                          </span>
                          <span
                            v-if="target.kind == 2"
                            class="text-dark text-xsmall bold"
                          >
                            Ciro Hedefi
                          </span>
                          <span
                            v-if="target.kind == 3"
                            class="text-dark text-xsmall bold"
                          >
                            Kategori Hedefi
                          </span>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <span
                            v-if="target.kind == 1"
                            class="text-secondary text-xsmaller weight-600"
                          >
                            {{
                              target.targetQuantity +
                              " Adet " +
                              target.product.name
                            }}
                          </span>
                          <span
                            v-if="target.kind == 3"
                            class="text-secondary text-xsmaller weight-600"
                          >
                            {{
                              target.targetQuantity +
                              " Adet " +
                              target.category.name
                            }}
                          </span>
                          <span
                            v-if="target.kind == 2"
                            class="text-secondary text-xsmaller weight-600"
                          >
                            {{ $toCurrency(target.targetQuantity) }}
                          </span>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="7"
                      vs-align="center"
                      class="px-1"
                    >
                      <vs-row vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-progress
                            :percent="
                              (target.targetProcess * 100) /
                              target.targetPersonals.length
                            "
                            :color="
                              target.kind == 2
                                ? 'rgb(142, 224, 232)'
                                : 'rgb(60, 232, 196)'
                            "
                          >
                          </vs-progress>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-col
                            v-if="target.status == 1"
                            vs-type="flex"
                            vs-w="8"
                            vs-justify="flex-start"
                          >
                            <span class="text-secondary bold text-xsmall">
                              {{
                                target.targetProcess + " Personel Tamamlamış"
                              }}
                            </span>
                          </vs-col>
                          <vs-col
                            v-if="target.status == 1"
                            vs-type="flex"
                            vs-w="4"
                            vs-justify="flex-end"
                          >
                            <span class="text-secondary bold text-xsmall">
                              {{ target.targetPersonals.length + " Personel" }}
                            </span>
                          </vs-col>
                          <vs-col
                            v-if="target.status == 2"
                            vs-type="flex"
                            vs-w="12"
                            vs-justify="flex-end"
                          >
                            <span
                              class="w-full text-center text-success bold text-smaller"
                            >
                              Tüm Personel({{ target.targetPersonals.length }})
                              Hedefe Ulaştı !
                            </span>
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="1"
                      vs-align="center"
                      vs-justify="center"
                      class="pl-1 mb-3"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="w-4 h-4 hover:text-danger stroke-current"
                        @click.stop="
                          deletedId = target.id;
                          deletePopupActive = true;
                        "
                      />
                    </vs-col>
                  </div>
                </vs-row>
              </vs-row>
            </vs-collapse-item>
          </vs-collapse>
        </vs-row>
      </vs-row>
    </vs-col>
    <vs-col
      id="targetReportSide"
      vs-type="flex"
      vs-sm="12"
      vs-lg="6"
      v-if="
        tableOptions.branch != null && Object.keys(bestSellersReport).length > 0
      "
    >
      <vs-row vs-type="block" vs-w="12" class="pl-3">
        <vs-row
          id="reportOptions"
          vs-type="flex"
          vs-w="12"
          vs-justify="center"
          vs-align="center"
        >
          <vs-col
            vs-type="flex"
            vs-w="9"
            class="px-1"
            vs-align="center"
            vs-justify="flex-start"
          >
            <span class="text-secondary text-medium-small mt-1 weight-600">
              {{ reportTableOptions.branch.name }} Raporları
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" class="px-1">
            <v-select
              class="w-full targetMonthSelect weight-500"
              :clearable="false"
              itemid="id"
              label="name"
              v-model="reportTableOptions.month"
              :options="$months()"
            />
          </vs-col>
        </vs-row>
        <vs-row
          id="reportHeaderChips"
          vs-type="flex"
          vs-w="12"
          class="mt-4"
          vs-align="center"
          vs-justify="space-between"
        >
          <vs-col
            vs-type="flex"
            vs-w="5.9"
            class="bg-white p-2 sale-box-shadow low-border-radius"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto" vs-align="center">
                <vs-button
                  size="large"
                  type="gradient"
                  radius
                  icon-pack="pickicon"
                  icon="icon-rich"
                  color="rgb(142, 224, 232)"
                />
              </vs-col>
              <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="text-medium-small2 bold"
                      style="color: rgb(142, 224, 232)"
                    >
                      {{ $toCurrency(bestSellersReport.totalGiroByMonth) }}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{ reportTableOptions.month.name + " Ayı Ciro" }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-w="5.9"
            class="bg-white p-2 sale-box-shadow low-border-radius"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="w-auto" vs-align="center">
                <vs-button
                  size="large"
                  type="gradient"
                  radius
                  icon-pack="pickicon"
                  icon="icon-products"
                  color="rgb(60, 232, 196)"
                />
              </vs-col>
              <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span
                      class="text-medium-small2 bold"
                      style="color: rgb(60, 232, 196)"
                    >
                      {{
                        bestSellersReport.totalSelledProductQuantityByMonth +
                        " Adet"
                      }}
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span class="text-secondary text-xsmall weight-600">
                      {{ reportTableOptions.month.name + " Ayı Satış Sayısı" }}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row
          id="bestSellerProducts"
          vs-type="flex"
          vs-w="12"
          class="mt-2 bg-white sale-box-shadow low-border-radius"
        >
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="flex-start"
            vs-align="center"
            class="pt-4 pb-1 px-4"
          >
            <span class="text-smaller text-secondary bold">
              En Çok Satılan Ürünler
            </span>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="12"
            id="bestSellerProductList"
            class="py-1"
          >
            <vs-row
              class="bestSellerProduct py-2"
              vs-type="flex"
              vs-w="12"
              vs-align="center"
              v-for="(product, index) in bestSellersReport.bestSellerProducts"
              :key="index"
            >
              <vs-col
                vs-type="flex"
                vs-w="0.5"
                class="mr-2"
                vs-justify="flex-end"
                vs-align="center"
              >
                <span class="text-primary bold text-xsmall">
                  {{ index + 1 }}.
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5" vs-align="center">
                <span class="text-dark bold text-xsmall">
                  {{ product.product.name }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="3"
                vs-justify="center"
                vs-align="center"
              >
                <span class="text-secondary bold text-xsmall">
                  {{ $toCurrency(product.amount) }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2.5"
                vs-justify="flex-end"
                vs-align="center"
              >
                <span class="text-primary bold text-xsmall">
                  {{ product.quantity }} Adet
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
        <vs-row
          id="bestSellerPersonals"
          vs-type="flex"
          vs-w="12"
          class="my-2 bg-white sale-box-shadow low-border-radius"
        >
          <vs-row
            vs-type="flex"
            vs-w="12"
            vs-justify="flex-start"
            vs-align="center"
            class="pt-4 pb-1 px-4"
          >
            <span class="text-smaller text-secondary bold">
              En Çok Satan Personeller
            </span>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="12"
            id="bestSellerPersonalList"
            class="py-1"
          >
            <vs-row
              class="bestSellerPersonal py-1"
              vs-type="flex"
              vs-w="12"
              vs-align="center"
              v-for="(personal, index) in bestSellersReport.bestSellerPersonals"
              :key="index"
            >
              <vs-col
                vs-type="flex"
                vs-w="0.5"
                class="mr-2"
                vs-justify="flex-end"
                vs-align="center"
              >
                <span class="text-primary bold text-xsmall">
                  {{ index + 1 }}.
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="1"
                vs-align="center"
                vs-justify="flex-start"
              >
                <vs-avatar :src="getAvatar(personal.personal.image)" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="4" vs-align="center">
                <span class="text-dark bold text-xsmall">
                  {{ personal.personal.name }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="3"
                vs-justify="center"
                vs-align="center"
              >
                <span class="text-secondary bold text-xsmall">
                  {{ $toCurrency(personal.amount) }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="2.5"
                vs-justify="flex-end"
                vs-align="center"
              >
                <span class="text-primary bold text-xsmall">
                  {{ personal.quantity }} Adet
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import { filterProductNameList } from "@/api/Filter.js";
import { getBestSellerProductAndPersonal } from "@/api/Reports.js";
import TargetReviewer from "./TargetReviewer.vue";
import {
  createTarget,
  deleteTarget,
  getTargetList,
  getTargetListForDealer,
} from "@/api/Target";
import { getBranchNameList } from "@/api/User";
import { isGranted } from "@/utils/auth";
import { getCategoryAndProduct } from "@/api/ProductCategory";
export default {
  components: {
    TargetReviewer,
  },
  data() {
    return {
      deletePopupActive: false,
      deletedId: null,
      newBranchTarget: null,
      newPersonalTarget: null,
      targetKinds: [
        {
          id: 1,
          name: "Ürün",
          origin: "Product",
        },
        {
          id: 2,
          name: "Ciro",
          origin: "Giro",
        },
        {
          id: 3,
          name: "Kategori",
          origin: "Category",
        },
      ],
      products: [],
      categories: [],
      bestSellersReport: {},
      reportTableOptions: {},
      daysToExpire: null,
      selectedTarget: {},
      tableOptions: {},
      targets: [],
      branches: [],
    };
  },
  methods: {
    submitNewTarget: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-1");
      if (
        !checker ||
        this.tableOptions.branch == null ||
        (this.newBranchTarget == {} && this.newPersonalTarget == {})
      )
        return;
      let obj = null;
      if (this.newPersonalTarget != null && this.newPersonalTarget != {}) {
        obj = {
          type: 2,
          targetQuantity: parseFloat(this.newPersonalTarget.targetQuantity),
          branch: this.tableOptions.branch,
          kind: this.newPersonalTarget.kind.id,
          product:
            this.newPersonalTarget.kind.id == 1
              ? this.newPersonalTarget.product
              : null,
          category:
            this.newPersonalTarget.kind.id == 3
              ? this.newPersonalTarget.category
              : null,
          month: this.tableOptions.month.id,
          year: parseInt(this.tableOptions.year),
        };
      } else if (this.newBranchTarget != null && this.newBranchTarget != {}) {
        obj = {
          type: 1,
          targetQuantity: parseFloat(this.newBranchTarget.targetQuantity),
          branch: this.tableOptions.branch,
          kind: this.newBranchTarget.kind.id,
          product:
            this.newBranchTarget.kind.id == 1
              ? this.newBranchTarget.product
              : null,
          category:
            this.newBranchTarget.kind.id == 3
              ? this.newBranchTarget.category
              : null,
          month: this.tableOptions.month.id,
          year: parseInt(this.tableOptions.year),
        };
      }
      /*if(this.newBranchTarget)
        this.newBranchTarget.targetQuantity = this.newBranchTarget.targetQuantity ? parseFloat(this.newBranchTarget.targetQuantity) : 0;
        if(this.newPersonalTarget)
        this.newPersonalTarget.targetQuantity = this.newPersonalTarget.targetQuantity ? parseFloat(this.newPersonalTarget.targetQuantity) : 0;
        */
      createTarget(obj)
        .then((res) => {
          if (res && res.status == 200) {
            this.targets.unshift(res.data);
            this.newPersonalTarget = null;
            this.newBranchTarget = null;
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Yeni Hedef Başarıyla Eklendi !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Yeni Hedef Eklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    escape() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    getAvatar(image) {
      if (image == null) return this.$nullImage;
      else return this.$baseUrl + "/" + image;
    },
    openTargetReviewer(target) {
      this.selectedTarget = target;
      this.$refs.targetReviewer.isActive = true;
    },
    deleteTarget(id) {
      deleteTarget(id)
        .then((res) => {
          if (res && res.status == 200) {
            let index = this.targets.findIndex((x) => x.id == id);
            this.targets.splice(index, 1);
            this.deletedId = null;
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Hata : " + res.status,
              text: "Hedef Başarıyla Silindi !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hedef Silinemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getBestSellerProductAndPersonal: function () {
      if (!this.reportTableOptions.branch || !this.reportTableOptions.month)
        return;
      getBestSellerProductAndPersonal(this.reportTableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            this.bestSellersReport = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Raporları Yüklenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getBranchNameList: function () {
      getBranchNameList()
        .then((res) => {
          if (res && res.status === 200) {
            this.branches = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Şube Listesi Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getTargetList: function () {
      if (this.$isRegionalCenterBranch()) {
        getTargetListForDealer(this.tableOptions)
          .then((res) => {
            if (res && res.status === 200) {
              this.targets = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hedefler Yüklenemedi !",
              });
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error,
            });
          });
      } else {
        getTargetList(this.tableOptions)
          .then((res) => {
            if (res && res.status === 200) {
              this.targets = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hedefler Yüklenemedi !",
              });
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: error,
            });
          });
      }
    },
  },
  computed: {
    branchTargets() {
      return this.targets.filter((x) => x.type == 1);
    },
    personalTargets() {
      return this.targets.filter((x) => x.type == 2);
    },
    newTargetPermission() {
      return isGranted("target_create");
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        if (val == null || val.branch == null) return;
        this.getTargetList();
        var today = this.$now.date();
        var totalDays = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        ).getDate();
        if (today.getMonth() + 1 > this.tableOptions.month.id)
          this.daysToExpire = null;
        else this.daysToExpire = totalDays - today.getDate();
        this.newBranchTarget = null;
        this.newPersonalTarget = null;
      },
    },
    "tableOptions.branch": {
      deep: true,
      handler(val) {
        this.reportTableOptions.branch = this.tableOptions.branch;
      },
    },
    reportTableOptions: {
      deep: true,
      handler(val) {
        if (val) this.getBestSellerProductAndPersonal();
      },
    },
  },
  created: async function () {
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.tableOptions = {
      year: this.$now.date().getFullYear().toString(),
      month: this.$months().find(
        (x) => x.id == this.$now.date().getMonth() + 1
      ),
      branch:
        this.$isCenterBranch() || this.$isRegionalCenterBranch()
          ? null
          : this.$currentUser.branch,
      product: null,
      category: null,
      personal: null,
    };
    this.reportTableOptions = {
      year: this.$now.date().getFullYear().toString(),
      month: this.$months().find(
        (x) => x.id == this.$now.date().getMonth() + 1
      ),
      branch: this.tableOptions.branch,
    };
    this.getBranchNameList();
    this.products = await filterProductNameList();
    var list = await getCategoryAndProduct();
    this.categories = list.map((s) => ({
      id: s.id,
      name: s.name,
    }));
    var today = this.$now.date();
    var totalDays = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    ).getDate();
    if (today.getMonth() + 1 < this.tableOptions.month.id)
      this.daysToExpire = null;
    else this.daysToExpire = totalDays - today.getDate();
  },
};
</script>

<style>
@media only screen and (max-height: 900px) {
  #targetsPage {
    overflow-y: auto !important;
  }
  #targetOptions .vs__dropdown-menu,
  #reportOptions .vs__dropdown-menu {
    max-height: 35vh !important;
  }

  #targetsPage,
  #personalTargets,
  #branchTargets,
  #branchTargets .con-content--item,
  #personalTargets .con-content--item,
  #bestSellerPersonals,
  #bestSellerProducts {
    max-height: unset;
  }
}
#reportOptions span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#targetReportSide {
  border-left: 1px solid #00000030;
}

#targetOptions .vs__selected {
  color: rgba(var(--vs-primary), 1) !important;
}

#reportOptions .vs__selected {
  color: rgba(var(--vs-dark), 1) !important;
}

#reportOptions {
  height: 36.8px;
}

#targetOptions .vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: 100% !important;
  min-width: unset !important;
}

#reportOptions .vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: 100% !important;
  min-width: unset !important;
}

#targetOptions .vs__dropdown-toggle {
  border: none !important;
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
  border-radius: 0;
  padding: 0 !important;
}

#reportOptions .vs__dropdown-toggle {
  border: none !important;
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
  border-radius: 0;
  padding: 0 !important;
}

#targetDetails .vs-collapse .vs-collapse-item--header i {
  font-size: 2.25rem;
}

.targetTypeAvatar i {
  text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3) !important;
  color: #000000;
}

.personalTargetRow:hover {
  background-color: #00000010;
}

.branchTargetRow:hover {
  background-color: #00000010;
}

#reportHeaderChips button {
  border-width: 2px !important;
}

#reportHeaderChips i {
  font-weight: bold;
}

#reportHeaderChips {
  height: 65px;
}

#targetsPage {
  height: calc(100vh - 100px);
}

.newTargetLine .con-content--item {
  min-height: 21vh !important;
}
.newTargetLine .vs-collapse-item--content {
  min-height: 21vh !important;
}

#personalTargets,
#branchTargets {
  max-height: calc(50vh - 80px);
}

#branchTargets .con-content--item,
#personalTargets .con-content--item {
  max-height: calc(50vh - 170px);
  overflow: auto;
}

#targetsPage .vs__selected-options {
  flex-wrap: nowrap !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

#bestSellerProducts {
  max-height: calc(50vh - 138px);
  overflow: auto;
}

#bestSellerPersonals {
  max-height: calc(50vh - 104px);
  overflow: auto;
}

#targetDetails .vs__search {
  font-size: 0.75rem;
}

#targetDetails .vs__selected {
  font-size: 0.75rem;
}

#targetDetails .vs-input--input {
  padding: 0.5rem !important;
  font-size: 0.75rem !important;
}

#targetDetails .vs-input--placeholder {
  padding: 0.4rem !important;
}

#targetDetails .vs__dropdown-menu {
  max-height: 15vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: 100% !important;
  min-width: unset !important;
  font-size: 0.75rem !important;
}
</style>
